<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header pt-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-0 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          Raporty
        </span>
        <h3 class="page-title">
          Raporty odpadu
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end"
        style="gap: 15px">
        <d-button
          theme="light"
          class="text-nowrap-dashboard"
          :disabled="filters.date_from === min_date_from"
          @click.prevent="setLastWeek">
          <i class="material-icons">double_arrow</i>
          Wróć do aktualnego tygodnia
        </d-button>
        <d-button
          theme="light"
          class="text-nowrap-dashboard"
          @click.prevent="show_returned_columns = !show_returned_columns">
          <i class="material-icons">{{ show_returned_columns ? 'visibility_off' : 'visibility' }}</i>
          {{ show_returned_columns ? 'Ukryj zwroty' : 'Pokaż zwroty' }}
        </d-button>
        <d-button
          theme="primary"
          class="text-nowrap-dashboard"
          :disabled="isLoadError || !isAllDataLoaded || !hasAnyData"
          @click.prevent="startEdit">
          <i class="material-icons">edit</i>
          Edytuj
        </d-button>
        <d-button
          theme="secondary"
          class="text-nowrap-dashboard"
          :disabled="isLoadError || !isAllDataLoaded || !hasAnyData || !is_edit_enabled"
          @click.prevent="stopEdit">
          <i class="material-icons">cancel</i>
          Anuluj
        </d-button>
        <d-button
          theme="success"
          class="text-nowrap-dashboard"
          :disabled="isLoadError || !isAllDataLoaded || !hasAnyData || !is_edit_enabled"
          @click.prevent="submitData">
          <i class="material-icons">save</i>
          Zapisz
        </d-button>
      </d-col>
    </d-row>
    <d-alert
      v-if="isLoadError"
      show
      theme="danger"
      class="mt-4">
      Wczytywanie danych nie powiodło się.
      <a
        href="javascript:window.location.reload();"
        class="alert-link">
        Odśwież stronę
      </a>
      aby spróbować ponownie.
    </d-alert>
    <template v-else>
      <d-row
        no-gutters
        class="page-header py-4">
        <d-col
          col
          sm="6"
          class="text-center order__date_top text-sm-left mb-4 mb-sm-0 align-items-center">
          <d-button
            class="order__date_top_button"
            @click.prevent="setPrevWeek"
            theme="light">
            <i
              class="material-icons"
              style="margin-left: 0.2rem">
              keyboard_arrow_left
            </i>
          </d-button>
          <p class="order__date_top_text">
            {{ filters.date_from }} <span class="text-primary ml-2 mr-2"> &ndash; </span> {{ dateTo }}
          </p>
          <d-button
            class="order__date_top_button"
            @click.prevent="setNextWeek"
            theme="light"
            :disabled="filters.date_from === min_date_from">
            <i
              class="material-icons"
              style="margin-left: 0.2rem">
              keyboard_arrow_right
            </i>
          </d-button>
        </d-col>
      </d-row>
      <d-row class="d-flex ml-0 mb-3 page-filters w-100">
        <validation-observer
          ref="product-waste-filters-form"
          tag="form"
          style="width: 100%;"
          class="d-flex">
          <validation-provider
            class="w-100 mr-2"
            :rules="'required'"
            name="shop_id"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                id="shop-id-select"
                :options="shops"
                :reduce="shop => shop.id"
                v-model="filters.shop_id"
                placeholder="Wybierz placówkę*"
                :state="errors.length ? 'invalid' : null"
                :searchable="false"
                label="name">
                <template
                  slot="option"
                  slot-scope="option">
                  <div class="d-center">
                    {{ option.name ? option.name : '' }}
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name ? option.name : '' }}
                  </div>
                </template>
              </v-select>
            </div>
            <div
              class="invalid-feedback pl-2"
              style="position: absolute;z-index: 2;margin-top: -1px;">
              {{ errors[0] }}
            </div>
          </validation-provider>

          <v-select
            class="ml-2 w-100"
            :options="products"
            :reduce="product => product.id"
            v-model="filters.product_id"
            placeholder="Wybierz produkt"
            :searchable="false"
            label="name">
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                {{ option.name ? option.name : '' }}
                <template v-if="option.show_in_form === 0"> (nie w formularzu klienta)</template>
              </div>
            </template>
            <template
              slot="selected-option"
              slot-scope="option">
              <div class="selected d-center">
                {{ option.name ? option.name : '' }}
              </div>
            </template>
          </v-select>

          <d-button
            theme="info"
            outline
            class="text-nowrap ml-2"
            @click.prevent="validateFiltersForm">Szukaj</d-button>
          <d-button
            theme="danger"
            outline
            class="text-nowrap ml-2"
            @click.prevent="clearFilters">Resetuj filtry</d-button>
        </validation-observer>
      </d-row>

      <d-alert
        :show="!filters.shop_id"
        theme="warning"
        class="mt-4">
        Aby załadować dane należy wybrać placówkę.
      </d-alert>

      <d-card class="w-100 mb-5">
        <table
          class="table table-hover mt-0 mb-0 full-width"
          style="table-layout: fixed;">
          <thead class="bg-light">
            <tr>
              <th
                scope="col"
                class="border-0">Produkt</th>
              <th
                scope="col"
                class="border-0 text-right"
                width="170">Wysłano do sklepu</th>
              <th
                scope="col"
                class="border-0 text-right"
                width="170">Sprzedano</th>
              <th
                v-if="show_returned_columns"
                scope="col"
                class="border-0 text-right"
                width="170">Wróciło do firmy</th>
              <th
                v-if="show_returned_columns"
                scope="col"
                class="border-0 text-right"
                width="120">Różnica w %</th>
            </tr>
          </thead>
          <tbody>
            <!-- GRUPY -->
            <template v-for="group in groups">
              <!-- Wiersz grupy -->
              <tr
                :key="group.key"
                class="group-row"
                :class="{ 'table-danger': group.percent_diff > 15 }"
                @click="toggleGroup(group.key)">
                <td class="align-middle">
                  <span class="group-name">
                    <i class="material-icons group-arrow">
                      {{ collapsed_groups[group.key] ? 'keyboard_arrow_right' : 'keyboard_arrow_down' }}
                    </i>
                    {{ group.name }}
                  </span>
                </td>
                <td class="text-right align-middle">
                  <span class="col-content-wrapper">
                    {{ group.sent }}
                    <span class="unit">{{ unitLabel(group.report_unit) }}</span>
                  </span>
                </td>
                <td
                  class="text-right align-middle"
                  @click.stop>
                  <span class="col-content-wrapper">
                    <input
                      v-if="is_edit_enabled"
                      :value="group.sold"
                      @input="onGroupSoldInput(group, $event.target.value)"
                      type="number"
                      :step="group.report_unit === 'PIECE' ? 1 : 0.01"
                      min="0"
                      class="form-control"
                      :tabindex="getTabIndex('group', group.key, 'sold')" />
                    <span v-else>{{ group.sold }}</span>
                    <span class="unit">{{ unitLabel(group.report_unit) }}</span>
                  </span>
                </td>
                <td
                  v-if="show_returned_columns"
                  class="text-right align-middle"
                  @click.stop>
                  <span class="col-content-wrapper">
                    <input
                      v-if="is_edit_enabled"
                      :value="group.returned"
                      @input="onGroupReturnedInput(group, $event.target.value)"
                      type="number"
                      :step="group.report_unit === 'PIECE' ? 1 : 0.01"
                      min="0"
                      class="form-control"
                      :tabindex="getTabIndex('group', group.key, 'returned')" />
                    <span v-else>{{ group.returned }}</span>
                    <span class="unit">{{ unitLabel(group.report_unit) }}</span>
                  </span>
                </td>
                <td
                  v-if="show_returned_columns"
                  class="text-right align-middle">
                  {{ group.percent_diff }}%
                </td>
              </tr>

              <!-- Wiersze produktów (rozwinięte) -->
              <tr
                v-for="product in group.products"
                v-show="!collapsed_groups[group.key]"
                :key="'product-' + product.id"
                :class="{ 'table-danger': product.percent_diff > 15 }">
                <td
                  class="align-middle"
                  style="padding-left: 2.5rem;">
                  {{ product.name }}
                </td>
                <td class="text-right align-middle">
                  <span class="col-content-wrapper">
                    {{ product.sent }}
                    <span class="unit">{{ unitLabel(product.report_unit) }}</span>
                  </span>
                </td>
                <td class="text-right align-middle">
                  <span class="col-content-wrapper">
                    <input
                      v-if="is_edit_enabled"
                      v-model.number="product.sold"
                      @input="onProductSoldInput(group)"
                      type="number"
                      :step="product.report_unit === 'PIECE' ? 1 : 0.01"
                      min="0"
                      class="form-control"
                      tabindex="-1" />
                    <span v-else>{{ product.sold }}</span>
                    <span class="unit">{{ unitLabel(product.report_unit) }}</span>
                  </span>
                </td>
                <td
                  v-if="show_returned_columns"
                  class="text-right align-middle">
                  <span class="col-content-wrapper">
                    <input
                      v-if="is_edit_enabled"
                      v-model.number="product.returned"
                      @input="onProductReturnedInput(group)"
                      type="number"
                      :step="product.report_unit === 'PIECE' ? 1 : 0.01"
                      min="0"
                      class="form-control"
                      tabindex="-1" />
                    <span v-else>{{ product.returned }}</span>
                    <span class="unit">{{ unitLabel(product.report_unit) }}</span>
                  </span>
                </td>
                <td
                  v-if="show_returned_columns"
                  class="text-right align-middle">
                  {{ product.percent_diff }}%
                </td>
              </tr>
            </template>

            <!-- POZYCJE DODATKOWE -->
            <tr
              v-if="extra_items.length > 0"
              class="group-row">
              <td
                :colspan="show_returned_columns ? 5 : 3"
                class="align-middle">
                Dodatkowe pozycje
              </td>
            </tr>
            <tr
              v-for="item in extra_items"
              :key="'extra-' + item.id">
              <td
                class="align-middle"
                style="padding-left: 2.5rem;">
                {{ item.name }}
              </td>
              <td class="text-right align-middle">
                &mdash;
              </td>
              <td class="text-right align-middle">
                <span class="col-content-wrapper">
                  <input
                    v-if="is_edit_enabled"
                    v-model.number="item.sold"
                    type="number"
                    step="0.01"
                    min="0"
                    class="form-control"
                    :tabindex="getTabIndex('extra', item.id, 'sold')" />
                  <span v-else>{{ item.sold }}</span>
                  <span class="unit">{{ unitLabel(item.report_unit) }}</span>
                </span>
              </td>
              <td
                v-if="show_returned_columns"
                class="text-right align-middle">
                <span class="col-content-wrapper">
                  <input
                    v-if="is_edit_enabled"
                    v-model.number="item.returned"
                    type="number"
                    step="0.01"
                    min="0"
                    class="form-control"
                    :tabindex="getTabIndex('extra', item.id, 'returned')" />
                  <span v-else>{{ item.returned }}</span>
                  <span class="unit">{{ unitLabel(item.report_unit) }}</span>
                </span>
              </td>
              <td
                v-if="show_returned_columns"
                class="text-right align-middle">
                &mdash;
              </td>
            </tr>

            <!-- Pusty stan -->
            <tr v-if="!hasAnyData">
              <td
                :colspan="show_returned_columns ? 5 : 3"
                class="text-center">
                Brak elementów do wyświetlenia&hellip;
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="!isAllDataLoaded"
          class="pb-3 pt-3 text-center overlay-loading">
          Trwa ładowanie danych&hellip;
        </div>
      </d-card>

      <d-row class="bg-light border rounded mx-0 mt-3 px-3 py-2 align-items-center">
        <d-col
          cols="auto"
          class="font-weight-bold px-0">
          Wróciło łącznie:
        </d-col>
        <d-col
          cols="2"
          class="d-flex align-items-center">
          <input
            v-if="is_edit_enabled"
            :value="total_returned_kg"
            @input="onTotalReturnedInput('KILOGRAM', $event.target.value)"
            type="number"
            step="0.01"
            min="0"
            class="form-control" />
          <span v-else>{{ total_returned_kg }}</span>
          <span class="ml-1">kg</span>
        </d-col>
        <d-col
          cols="2"
          class="d-flex align-items-center">
          <input
            v-if="is_edit_enabled"
            :value="total_returned_pcs"
            @input="onTotalReturnedInput('PIECE', $event.target.value)"
            type="number"
            step="1"
            min="0"
            class="form-control" />
          <span v-else>{{ total_returned_pcs }}</span>
          <span class="ml-1">szt.</span>
        </d-col>
      </d-row>
    </template>
  </d-container>
</template>

<script>
import Vue from 'vue';
import debounce from 'lodash.debounce';
import FormUtils from '@/utils/FormUtils.js';
import HasFilters from '@/mixins/HasFilters.vue';

const moment = require('moment');

export default {
  name: 'product-waste',
  mixins: [
    HasFilters,
  ],
  data () {
    return {
      filters: {
        date_from: null,
        product_id: null,
        shop_id: null
      },
      groups: [],
      extra_items: [],
      collapsed_groups: {},
      show_returned_columns: false,
      is_edit_enabled: false,
      load_error: false,
      loaded: false,
      min_date_from: null,
      products: [],
      products_load_error: false,
      products_loaded: false,
      shops: [],
      shops_load_error: false,
      shops_loaded: false,
      total_returned_kg: 0,
      total_returned_pcs: 0
    };
  },
  computed: {
    isAllDataLoaded () {
      if (this.filters.shop_id) {
        return this.loaded && this.shops_loaded && this.products_loaded;
      }
      return this.shops_loaded && this.products_loaded;
    },
    isLoadError () {
      return this.load_error || this.shops_load_error || this.products_load_error;
    },
    hasAnyData () {
      return this.groups.length > 0 || this.extra_items.length > 0;
    },
    dateTo () {
      if (!this.filters.date_from) {
        return '';
      }
      const lastDayOfWeek = moment(this.filters.date_from).endOf('isoWeek');
      return lastDayOfWeek.format('YYYY-MM-DD');
    }
  },
  watch: {
    'filters.date_from': function (value) {
      if (!value || !this.filters.shop_id || !this.loaded) {
        return;
      }
      this.debouncedLoadFilteredData();
    },
  },
  mounted () {
    this.setLastWeek();
    this.loadShops();
    this.loadProducts();
    if (this.filters.shop_id) {
      this.debouncedLoadFilteredData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadFilteredData () {
      this.loaded = false;
      this.load_error = false;
      let where = {
        shop_id: this.filters.shop_id,
        date_from: this.filters.date_from,
        product_id: this.filters.product_id
      };

      this.$http.post('/product-waste/items', { where }).then(response => {
        this.groups = response.data.data || [];
        this.extra_items = response.data.extra_items || [];

        let collapsed = {};
        this.groups.forEach(group => {
          collapsed[group.key] = true;
        });
        this.collapsed_groups = collapsed;

        this.recalcTotalReturned();
        this.loaded = true;
      }).catch(() => {
        this.load_error = true;
        this.loaded = true;
      });
    },
    setPrevWeek () {
      if (!this.filters.date_from) {
        this.setLastWeek();
        return;
      }
      const prevWeek = moment(this.filters.date_from).subtract(1, 'weeks');
      const firstDayOfPrevWeek = prevWeek.startOf('isoWeek');

      this.filters.date_from = firstDayOfPrevWeek.format('YYYY-MM-DD');
    },
    setNextWeek () {
      if (this.filters.date_from === this.min_date_from) {
        return;
      }

      if (!this.filters.date_from) {
        this.setLastWeek();
        return;
      }
      const nextWeek = moment(this.filters.date_from).add(1, 'weeks');
      const firstDayOfNextWeek = nextWeek.startOf('isoWeek');

      this.filters.date_from = firstDayOfNextWeek.format('YYYY-MM-DD');
    },
    setLastWeek () {
      const lastWeek = moment().subtract(1, 'weeks');
      const firstDayOfLastWeek = lastWeek.startOf('isoWeek');

      this.filters.date_from = firstDayOfLastWeek.format('YYYY-MM-DD');
      this.min_date_from = firstDayOfLastWeek.format('YYYY-MM-DD');
    },
    loadShops () {
      Vue.set(this, 'shops_loaded', false);
      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/shops/items',
        params: {
          pagination: false
        },
        outputKey: 'shops',
        errorKey: 'shops_load_error',
        loadedKey: 'shops_loaded'
      });
    },
    loadProducts () {
      Vue.set(this, 'products_loaded', false);
      FormUtils.loadAdditionalData(this, {
        endpoint: '/products/items',
        params: {
          pagination: false
        },
        outputKey: 'products',
        errorKey: 'products_load_error',
        loadedKey: 'products_loaded'
      });
    },
    clearFilters () {
      this.filters.product_id = null;
      this.debouncedLoadFilteredData();
    },
    validateFiltersForm () {
      FormUtils.validate(this.$refs['product-waste-filters-form'], this.debouncedLoadFilteredData);

      if (!this.filters.shop_id) {
        this.groups = [];
        this.extra_items = [];
      }
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    startEdit () {
      this.is_edit_enabled = true;
      this.$nextTick(() => {
        let firstInput = this.$el.querySelector('.group-row input[tabindex="1"]');
        if (firstInput) {
          firstInput.focus();
        }
      });
    },
    stopEdit () {
      this.is_edit_enabled = false;
      this.debouncedLoadFilteredData();
    },
    submitData () {
      let dataToSend = this.prepareDataToSend();

      FormUtils.submit(this, {
        endpoint: '/product-waste/store',
        formData: dataToSend,
        successTitle: 'Zapisano raport',
        successText: 'Raport odpadu został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja raportu odpadu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.stopEdit();
        }
      });
    },
    prepareDataToSend () {
      let dataToSend = {
        shop_id: this.filters.shop_id,
        start_date: this.filters.date_from,
        products: [],
        extra_items: []
      };

      this.groups.forEach(group => {
        group.products.forEach(product => {
          dataToSend.products.push({
            product_id: product.id,
            sold: Number(product.sold),
            returned: Number(product.returned)
          });
        });
      });

      this.extra_items.forEach(item => {
        dataToSend.extra_items.push({
          extra_item_id: item.id,
          sold: Number(item.sold),
          returned: Number(item.returned)
        });
      });

      return dataToSend;
    },
    toggleGroup (groupKey) {
      Vue.set(this.collapsed_groups, groupKey, !this.collapsed_groups[groupKey]);
    },
    onGroupSoldInput (group, newValue) {
      let total = Number(newValue);
      let step = group.report_unit === 'PIECE' ? 1 : 0.01;
      let distributed = this.distribute(total, group.products, step);
      group.products.forEach((product, idx) => {
        Vue.set(product, 'sold', distributed[idx]);
      });
      Vue.set(group, 'sold', total);
      this.recalcGroupPercentDiff(group);
    },
    onGroupReturnedInput (group, newValue) {
      let total = Number(newValue);
      let step = group.report_unit === 'PIECE' ? 1 : 0.01;
      let distributed = this.distribute(total, group.products, step);
      group.products.forEach((product, idx) => {
        Vue.set(product, 'returned', distributed[idx]);
      });
      Vue.set(group, 'returned', total);
      this.recalcGroupPercentDiff(group);
      this.recalcTotalReturned();
    },
    onProductSoldInput (group) {
      let sum = group.products.reduce((acc, prod) => acc + Number(prod.sold), 0);
      Vue.set(group, 'sold', Number(sum.toFixed(2)));
      this.recalcGroupPercentDiff(group);
    },
    onProductReturnedInput (group) {
      let sum = group.products.reduce((acc, prod) => acc + Number(prod.returned), 0);
      Vue.set(group, 'returned', Number(sum.toFixed(2)));
      this.recalcGroupPercentDiff(group);
      this.recalcTotalReturned();
    },
    recalcGroupPercentDiff (group) {
      if (Number(group.sent) > 0) {
        let diff = Number(group.sent) - Number(group.sold) - Number(group.returned);
        Vue.set(group, 'percent_diff', Number(((diff / Number(group.sent)) * 100).toFixed(2)));
      }
    },
    distribute (total, products, step = 0.01) {
      let units = Math.round(total / step);
      let sentSum = products.reduce((acc, prod) => acc + Number(prod.sent), 0);
      let weights = products.map(prod => (sentSum > 0 ? Number(prod.sent) : 1));
      let weightSum = weights.reduce((acc, weight) => acc + weight, 0);
      let raw = weights.map(weight => (units * weight) / weightSum);
      let result = raw.map(Math.floor);
      let rest = units - result.reduce((acc, val) => acc + val, 0);
      raw.map((val, idx) => ({ idx, frac: val - Math.floor(val) }))
        .sort((first, second) => second.frac - first.frac)
        .forEach(({ idx }) => {
          if (rest > 0) {
            result[idx] += 1; rest -= 1;
          }
      });
      return result.map(val => Number((val * step).toFixed(2)));
    },
    onTotalReturnedInput (unit, newValue) {
      if (!this.show_returned_columns) {
        this.show_returned_columns = true;
      }

      let total = Number(newValue);
      let step = unit === 'PIECE' ? 1 : 0.01;

      let matchingGroups = this.groups.filter(g => g.report_unit === unit);
      let matchingExtras = this.extra_items.filter(i => i.report_unit === unit);

      // Zbieramy wszystkie "odbiorniki" (grupy + extra items) z ich sent
      let targets = [];
      matchingGroups.forEach(group => {
        targets.push({ type: 'group', ref: group, sent: Number(group.sent) });
      });
      matchingExtras.forEach(item => {
        targets.push({ type: 'extra', ref: item, sent: Number(item.sent || 0) });
      });

      if (targets.length === 0) {
        return;
      }

      // Rozprowadzamy sumę na targety proporcjonalnie do sent
      let sentSum = targets.reduce((acc, t) => acc + t.sent, 0);
      let weights = targets.map(t => (sentSum > 0 ? t.sent : 1));
      let weightSum = weights.reduce((acc, w) => acc + w, 0);
      let units = Math.round(total / step);
      let raw = weights.map(w => (units * w) / weightSum);
      let result = raw.map(Math.floor);
      let rest = units - result.reduce((acc, val) => acc + val, 0);
      raw.map((val, idx) => ({ idx, frac: val - Math.floor(val) }))
        .sort((first, second) => second.frac - first.frac)
        .forEach(({ idx }) => {
          if (rest > 0) {
            result[idx] += 1; rest -= 1;
          }
      });
      let distributed = result.map(val => Number((val * step).toFixed(2)));

      // Przypisujemy rozprowadzone wartości
      targets.forEach((target, idx) => {
        if (target.type === 'group') {
          let group = target.ref;
          // Rozprowadzamy na produkty w grupie
          let groupDistributed = this.distribute(distributed[idx], group.products, step);
          group.products.forEach((product, pIdx) => {
            Vue.set(product, 'returned', groupDistributed[pIdx]);
          });
          Vue.set(group, 'returned', distributed[idx]);
          this.recalcGroupPercentDiff(group);
        } else {
          Vue.set(target.ref, 'returned', distributed[idx]);
        }
      });

      // Aktualizujemy sumę
      if (unit === 'KILOGRAM') {
        this.total_returned_kg = total;
      } else {
        this.total_returned_pcs = total;
      }
    },
    recalcTotalReturned () {
      let kg = 0;
      let pcs = 0;
      this.groups.forEach(group => {
        if (group.report_unit === 'KILOGRAM') {
          kg += Number(group.returned);
        } else {
          pcs += Number(group.returned);
        }
      });
      this.extra_items.forEach(item => {
        if (item.report_unit === 'KILOGRAM') {
          kg += Number(item.returned);
        } else {
          pcs += Number(item.returned);
        }
      });
      this.total_returned_kg = Number(kg.toFixed(2));
      this.total_returned_pcs = Number(pcs.toFixed(2));
    },
    unitLabel (reportUnit) {
      return reportUnit === 'KILOGRAM' ? 'kg' : 'szt.';
    },
    getTabIndex (type, key, field) {
      let index = 1;
      let soldCount = this.groups.length + this.extra_items.length;

      if (field === 'sold') {
        if (type === 'group') {
          index += this.groups.findIndex(grp => grp.key === key);
        } else {
          index += this.groups.length + this.extra_items.findIndex(item => item.id === key);
        }
      } else if (type === 'group') {
        index += soldCount + this.groups.findIndex(grp => grp.key === key);
      } else {
        index += soldCount + this.groups.length + this.extra_items.findIndex(item => item.id === key);
      }

      return index;
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/order-list';

.group-row {
  cursor: pointer;
  user-select: none;
  background-color: #f8f9fa;

  td {
    font-weight: 500;
  }

  &:hover {
    background-color: #e9ecef !important;
  }
}

.group-name {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.group-arrow {
  font-size: 20px;
  color: #868e96;
}

.col-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  white-space: nowrap;

  .form-control {
    width: 100px;
    min-width: 100px;
  }

  .unit {
    min-width: 28px;
    text-align: left;
  }
}

</style>
